/**
 * AI Coding 组件的示例数据
 */

export const cloudFunctionExamples = [
  {
    title: '用户管理',
    items: [
      { text: '实现用户注册（带用户名和密码验证）', query: '实现一个用户注册的云函数，需要验证用户名长度不小于6位，密码必须包含字母和数字且不少于8位' },
      { text: '用户登录（带 Token 返回）', query: '实现用户登录云函数，验证账号密码并返回用户 Token' },
      { text: '重置用户密码', query: '实现重置用户密码的云函数，通过邮箱验证' }
    ]
  },
  {
    title: '数据操作',
    items: [
      { text: '分页查询数据（支持排序和筛选）', query: '实现一个分页查询云函数，支持按时间排序和状态筛选，每页10条数据' },
      { text: '新增数据', query: '实现一个新增数据到 test表的云函数，包含字段 name' },
      { text: '更新数据', query: '实现一个更新数据test表的云函数，支持按id更新指定字段' },
      { text: '删除数据', query: '实现一个删除数据test表的云函数，支持按id删除单条或多条记录' }
    ]
  },
  {
    title: '高级功能',
    items: [
      { text: '获取附近的商家', query: '实现一个获取附近商家的云函数，支持按距离排序和类型筛选' },
      { text: '文件定时清理', query: '实现一个自动清理30天前临时文件的云函数' },
      { text: '清理表过期数据', query: '实现一个数据统计test表云函数，删除30天前过期的数据' }
    ]
  }
]

export const createTableExamples = [
  {
    title: '常用业务表',
    items: [
      { text: '用户信息表', query: '创建一个用户信息表，包含昵称、头像、手机号、性别、年龄、个人简介' },
      { text: '商品表', query: '创建一个商品表，包含商品名称、价格、库存数量、商品图片、商品描述、是否上架' },
      { text: '订单表', query: '创建一个订单表，包含订单号、用户ID（Pointer关联_User）、总金额、订单状态、收货地址、备注' },
      { text: '文章表', query: '创建一个文章表，包含标题、内容、作者、封面图片、阅读数、点赞数、是否发布' }
    ]
  },
  {
    title: '社交与互动',
    items: [
      { text: '评论表', query: '创建一个评论表，包含评论内容、评论用户（Pointer关联_User）、目标ID、点赞数、是否置顶' },
      { text: '消息通知表', query: '创建一个消息通知表，包含标题、内容、接收用户、消息类型、是否已读、发送时间' }
    ]
  },
  {
    title: '其他场景',
    items: [
      { text: '配置表', query: '创建一个系统配置表，包含配置键名、配置值（Object类型）、描述说明、是否启用' },
      { text: '签到记录表', query: '创建一个签到记录表，包含用户（Pointer关联_User）、签到日期、连续签到天数、获得积分' }
    ]
  }
]
